import { http } from './http';

export function getMediaDetail(category, id, { language } = {}) {
  const params = language ? { language } : undefined;
  return http.get(`/api/v1/media/${category}/${id}`, { params }).then((r) => r.data);
}
